'use strict';

angular.module('atex.dam').controller('DamMailModalController', ['$scope', '$q', '$translate',
	function($scope, $q, $translate) {
		$scope.mail = {};
		$scope.mail.to = [];
		if($scope.rule.useSystemUsers !== true) {
			$scope.mail.to.push($scope.toAddress);
		}
		$scope.mail.disabled = !$scope.rule.askAddress;
		$scope.panelTitle = $translate.getTranslationTable().__SEND_CONTENT__;

		$scope.doSend = function() {
			$scope.senderScope.send($scope.ruleId, $scope.idlist, $scope.mail, $scope.rule.useSystemUsers);
			$scope.doCancel();

		};

		$scope.isMessageValid =  function() {
			if($scope.rule.useSystemUsers !== true) {
				return (($scope.mail.to) && ($scope.mail.to.length>0)) && (($scope.mail.body) && (($scope.mail.subject)));
			} else {
				return (($scope.mail.to) && ($scope.mail.to.length>0));
			}

		};

	}
]);